import type { PrimeVuePTOptions } from 'primevue/config';

import { cva } from '@/helpers/cva';

const boxVariants = cva({
  base: 'flex size-full items-center justify-center rounded-md border-2 text-white transition-colors peer-focus-visible/input:border-[--v3-input-field-inputhoverbordercolor] peer-focus-visible/input:shadow-[0_0_0_2.8px_#bfdbfe]',
  variants: {
    isDisabled: {
      true: 'opacity-6',
    },
    isSelected: {
      false: 'border-[--v3-checkbox-checkboxborder] bg-white peer-hover/input:border-[--v3-input-field-inputhoverbordercolor]',
      true: 'border-[--v3-checkbox-checkboxactivebg] bg-[--v3-checkbox-checkboxactivebordercolor] peer-hover/input:bg-[--v3-checkbox-checkboxactivehoverbg] [&]:peer-hover/input:border-[--v3-checkbox-checkboxactivehoverbordercolor]',
    },
  },
});

export default {
  box: ({ instance = {} }) => ({
    class: boxVariants({
      isDisabled: !!instance.disabled,
      isSelected: !!instance.checked,
    }),
  }),
  icon: {
    class: 'icon',
  },
  input: {
    class: 'peer/input absolute inset-0 opacity-0 z-10 appearance-none cursor-pointer',
  },
  root: {
    class: 'relative size-6 inline-flex align-bottom',
  },
} satisfies PrimeVuePTOptions['checkbox'];
